export class CartTimeUtility {
  private _currentDate: Date;

  private constructor() {
    this._currentDate = new Date();
    // @ts-ignore
    CartTimeUtility.updateInterval = setInterval(
      () => {
        this._currentDate = new Date();
      },
      1000,
    );
  }

  public getRemainingTime(fromTimeStamp: Date): number {
    const orderChangedTime = Math.floor((this.currentDate as any - (fromTimeStamp as any)) / 1000);
    return CartTimeUtility.EXPIRATION_INTERVAL - orderChangedTime;
  }

  public shutdown(): void {
    if (CartTimeUtility.updateInterval) {
      clearInterval(CartTimeUtility.updateInterval);
    }
  }

  /** 15 Minutes (in seconds) to expiration of cart */
  public static EXPIRATION_INTERVAL: number = 15 * 60;

  public static getInstance(): CartTimeUtility {
    if (!CartTimeUtility.instance) {
      CartTimeUtility.instance = new CartTimeUtility();
    }

    return CartTimeUtility.instance;
  }

  private static updateInterval: number | null = null;
  private static instance: CartTimeUtility;

  get currentDate(): Date {
    return this._currentDate;
  }
}
